<button mat-button [matMenuTriggerFor]="languageMenu" (click)="chevronIcon.set('expand_less')" data-testid="language-switcher-button">
    {{ currentLocale() | languageCode | uppercase }}
    <mat-icon>{{ chevronIcon() }}</mat-icon>
</button>

<mat-menu #languageMenu="matMenu" (closed)="chevronIcon.set('expand_more')" xPosition="before" yPosition="below">
    @for (pair of countryLanguagePairs; track pair.locale) {
        <button mat-menu-item (click)="languageSwitcherService.changeLocale(pair.locale)" [attr.data-testid]="pair.locale + '-button'">
            <div class="flex items-center gap-2" [class.selected-locale]="currentLocale() === pair.locale">
                <span class="flag flag-{{ pair.locale | countryCode }}"></span>
                {{ languageCountryType[pair.locale]! | translate }}
            </div>
        </button>
    }
</mat-menu>
